// Institute of Design and Innovation (email idi@unm.edu). //

import { RouteLocation } from 'vue-router'
import store from '../store/store'

/**
 * Navigation guard that requires the user to be logged in
 */
export default async function (to: RouteLocation, from: RouteLocation, next) {
  if (store.state.isAdmin) {
    next('/calendar')
  } else {
    next('/schedule')
  }
}
